"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrackingClientError = exports.ErrorMessage = void 0;
var ErrorMessage;
(function (ErrorMessage) {
    ErrorMessage["NOT_INITIALIZED"] = "TrackingClient has not been initialized. Use initialize() to create an instance.";
    ErrorMessage["NO_TRACKER"] = "Initialization failed: No tracking implementation provided. Please provide an instance that implements the Tracking interface.";
    ErrorMessage["ALREADY_INITIALIZED"] = "Initialization failed: TrackingClient is already initialized. Use getInstance() to access the existing instance.";
    ErrorMessage["NO_URL"] = "No URL found. Please ensure that the TrackingClient is initialized in a browser environment.";
})(ErrorMessage || (exports.ErrorMessage = ErrorMessage = {}));
class TrackingClientError extends Error {
    constructor(message) {
        super(message);
        this.name = "TrackingClientError";
    }
}
exports.TrackingClientError = TrackingClientError;
//# sourceMappingURL=errors.js.map